import React from 'react';
import { getThemeStyles, useThemeObserver } from '@atlaskit/tokens';
export var useUnsetGlobalTheme = function useUnsetGlobalTheme(targetElement) {
  var idsToUnset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['light', 'dark', 'spacing'];
  var _useThemeObserver = useThemeObserver(),
    colorMode = _useThemeObserver.colorMode,
    dark = _useThemeObserver.dark,
    light = _useThemeObserver.light,
    spacing = _useThemeObserver.spacing,
    typography = _useThemeObserver.typography,
    UNSAFE_themeOptions = _useThemeObserver.UNSAFE_themeOptions;
  React.useEffect(function () {
    if (targetElement) {
      getThemeStyles().then(function (themeStyles) {
        themeStyles.forEach(function (themeStyle) {
          if (idsToUnset.includes(themeStyle.id)) {
            var allCssVariables = themeStyle.css.match(/--[\w-]+/g); // output => ['--ds-text', '--ds-text-accent-lime']
            allCssVariables === null || allCssVariables === void 0 || allCssVariables.forEach(function (cssVariable) {
              targetElement.style.setProperty(cssVariable, 'initial');
            });
          }
        });
      });
    }
  }, [targetElement, idsToUnset, colorMode, dark, light, spacing, typography, UNSAFE_themeOptions]);
};